import ko from "knockout";
import dateHelper from "flow/utils/dateHelper";
import { registerKnockoutExtension } from "flow/knockout/register";

declare global {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    interface KnockoutExtenders {
        cultureTime(target: KnockoutObservable<string>, includeSeconds?: boolean): KnockoutComputed<string>;
    }
}

registerKnockoutExtension("cultureTime", function (target: KnockoutObservable<string>) {
    //create a writeable computed observable to intercept writes to our observable
    const result = ko
        .pureComputed<string>({
            read() {
                return dateHelper.toLocalTimeFormat(target(), false);
            },
            write(newValue: string) {
                const current = target();

                const valueToWrite = dateHelper.fromLocalTimeFormat(newValue, false);

                //only write if it changed
                if (valueToWrite !== current) {
                    target(valueToWrite);
                } else if (newValue !== target()) {
                    result.notifySubscribers();
                }
            }
        })
        .extend({
            notify: "always"
        });

    //initialize with current value to make sure it is rounded appropriately
    result(target());

    //return the new computed observable
    return result;
});
